import { render, staticRenderFns } from "./type_inout.vue?vue&type=template&id=5512e97c&scoped=true&"
import script from "./type_inout.vue?vue&type=script&lang=js&"
export * from "./type_inout.vue?vue&type=script&lang=js&"
import style0 from "./type_inout.vue?vue&type=style&index=0&id=5512e97c&scoped=true&lang=css&"
import style1 from "./type_inout.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512e97c",
  null
  
)

export default component.exports